import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { useDispatch } from "react-redux";
import { AuthApi } from "./api/auth-api";
import { OpportunityApi } from "./api/opportunity-api";
import { SSOAuthApi } from "./api/sso-auth-api";
import AuthReducer from "./slices/authSlice";

export const store = configureStore({
  reducer: {
    [OpportunityApi.reducerPath]: OpportunityApi.reducer,
    [AuthApi.reducerPath]: AuthApi.reducer,
    auth: AuthReducer,
    [SSOAuthApi.reducerPath]: SSOAuthApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(OpportunityApi.middleware, AuthApi.middleware, SSOAuthApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
